export const POLICY_INIT_PAGE = 1;

export const POLICY_PAGESZ = 9;